import React from "react";
import "./HeaderLower.css";
function HeaderLower() {
  return (
    <div className="header_lower">
      Enter The Kittle's Furniture "Rest Test & Win" $5,000 Shopping Spree Sweepstakes

    </div>
  );
}
export default HeaderLower;
